export default "__VITE_ASSET__BYUl8zZ1__"